import { useState } from "react";

import "./Reviews.css";

import RatingSummary from "./components/RatingSummary";
import RatingDistribution from "./components/RatingDistribution";
import ReviewCard from "./components/ReviewCard";
import ReplyModal from "./components/ReplyModal";

import useReviews from "./hooks/useReviews";

function Reviews() {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("All");
  const [selectedReview, setSelectedReview] = useState(null);

  const {
    reviews,
    stats,
    loading,
    error,
    replyToReview,
    updateReply,
  } = useReviews();

  const filteredReviews = reviews.filter((item) => {
    const customerName =
      item.customer?.name || "";

    const comment =
      item.comment || "";

    const matchesSearch =
      customerName
        .toLowerCase()
        .includes(search.toLowerCase()) ||
      comment
        .toLowerCase()
        .includes(search.toLowerCase());

    const matchesFilter =
      filter === "All"
        ? true
        : item.rating === Number(filter);

    return matchesSearch && matchesFilter;
  });

  const handleReplySubmit = async (message) => {
    if (!selectedReview) return;

    let success = false;

    if (selectedReview.providerReply?.message) {
      success = await updateReply(
        selectedReview._id,
        message
      );
    } else {
      success = await replyToReview(
        selectedReview._id,
        message
      );
    }

    if (success) {
      setSelectedReview(null);
    }
  };

  if (loading) {
    return (
      <div className="reviews-page">
        <h2>Loading Reviews...</h2>
      </div>
    );
  }

  if (error) {
    return (
      <div className="reviews-page">
        <h2>{error}</h2>
      </div>
    );
  }

  return (
    <div className="reviews-page">

      <div className="reviews-header">
        <div>
          <h1>Reviews</h1>
          <p>
            See what your customers are saying
            about your business.
          </p>
        </div>
      </div>

      <RatingSummary
        reviews={reviews}
        stats={stats}
      />

      <RatingDistribution
        reviews={reviews}
        stats={stats}
      />

      <div className="review-toolbar">

        <input
          type="text"
          placeholder="Search reviews..."
          value={search}
          onChange={(e) =>
            setSearch(e.target.value)
          }
        />

        <select
          value={filter}
          onChange={(e) =>
            setFilter(e.target.value)
          }
        >
          <option value="All">All Ratings</option>
          <option value="5">5 ★</option>
          <option value="4">4 ★</option>
          <option value="3">3 ★</option>
          <option value="2">2 ★</option>
          <option value="1">1 ★</option>
        </select>

      </div>

      <div className="reviews-list">

        {filteredReviews.length === 0 ? (
          <div className="no-reviews">
            No Reviews Found
          </div>
        ) : (
          filteredReviews.map((review) => (
            <ReviewCard
              key={review._id}
              review={review}
              onReply={() =>
                setSelectedReview(review)
              }
            />
          ))
        )}

      </div>

      {selectedReview && (
        <ReplyModal
          review={selectedReview}
          onClose={() =>
            setSelectedReview(null)
          }
          onSubmit={handleReplySubmit}
        />
      )}

    </div>
  );
}

export default Reviews;